/** Optional GA4 page and store-click measurement; disabled without a real ID.
 * Related: main.js, app-router.js, .env.example.
 */
export const initAnalytics = () => {
  const id = import.meta.env.VITE_GA_MEASUREMENT_ID;
  if (!/^G-[A-Z0-9]+$/.test(id || '')) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', id, { send_page_view: false });
  const script = document.createElement('script');
  script.async = true; script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href);
    if (url.hostname !== 'play.google.com' && url.hostname !== 'xiangqionline.com') return;
    window.gtag('event', 'store_click', {
      store: url.hostname, game_id: url.searchParams.get('id') || 'xiangqi',
      link_url: url.href, page_path: location.pathname, transport_type: 'beacon',
    });
  });
};
export const trackPageView = () => {
  if (location.pathname.startsWith('/admin')) return;
  window.gtag?.('event', 'page_view', { page_title: document.title, page_location: location.href, page_path: location.pathname });
};
